
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, Settings, FileText } from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const ProfileGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Profile & Documents</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.SETTINGS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.SETTINGS}>
                <User className="h-5 w-5" />
                <span>Profile Settings</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.SERVICES) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.SERVICES}>
                <Settings className="h-5 w-5" />
                <span>Services & Pricing</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.DOCUMENTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.DOCUMENTS}>
                <FileText className="h-5 w-5" />
                <span>Professional Documents</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default ProfileGroup;
